import gql from 'graphql-tag';

export default gql`
  query getProjectDesignProfile($projectId: Int!) {
    projects_by_pk(project_id: $projectId) { project_id group_id design_profile_id }
  }
`;
